<template>
  <div @click="$emit('click', route)" :class="['aside-menu-item hover-scale', isActive]">
    <div class="circle"></div>
    <i v-if="isLoading" class="el-icon-loading"></i>
    <RouteIcon v-else :route="route" />
    <div class="route-name">
      <span>{{ route.name }}</span>
      <el-tag v-if="route.meta.isNew" class="new" type="primary" effect="dark" size="mini">new</el-tag>
    </div>
  </div>
</template>

<script>
import RouteIcon from './RouteIcon'
import { mapGetters } from 'vuex'
export default {
  components: {
    RouteIcon,
  },
  props: {
    route: Object,
  },
  computed: {
    ...mapGetters(['loaders']),
    isActive() {
      const isActive = this.$route.name == this.route.name
      return (isActive && 'active') || ''
    },
    isLoading() {
      return this.loaders[this.route.meta.loaderKey]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles';
.hover-scale {
  transition: all 120ms;
  &:hover {
    padding-left: 1.5em;
  }
}
.aside-menu-item {
  --p-color: var(--color);
  cursor: pointer;
  padding: 0.9em 1em;
  display: flex;
  align-items: center;
  font-size: 0.8em;
  font-weight: bold;
  text-transform: capitalize;
  background-blend-mode: color-dodge;
  border-top-left-radius: 5em;
  border-bottom-left-radius: 5em;

  > *:not(:last-child) {
    margin-right: 5px;
  }
  .route-name {
    display: flex;
    > *:not(:last-child) {
      margin-right: 5px;
    }
    .el-tag--mini {
      height: auto;
      padding: 2px 5px;
      line-height: 1em;
      font-size: 0.8em;
      align-self: center;
    }
  }
  &.active {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.082);
  }
  // .circle{
  //   width: 6px;
  //   height: 6px;
  //   border-radius: 10px;
  //   background: var(--p-color);
  // }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1em;
    font-weight: bold;
    color: var(--p-color);
    // color: rgb(210, 217, 221);
  }
}
</style>
